module.exports = __webpack_public_path__ + "img/bg.a38fe8f0.png";